//@flow

import React from "react";

export const BrandContext = React.createContext<string | null>(null);
